import React, { useState, useEffect } from "react";
import store from "store";
import { transitions, pages } from "../../constants";
import { RUN_MODES, runMode } from "../../config";
import { submitOtp, requestOtp, getStatus } from "../../api";
import FixedErrMsgArea from "../../components/FixedErrMessageArea";
const OTPVerify = ({ state, setState, runTransition, gotoPage }) => {
  const otpCodeTxtRef = React.createRef();
  const [error, setError] = React.useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // clearPersistStates();
    const t = transitions.phoneVerify;
    runTransition(t);
  }, []);
  return (
    <div className="otp-verify-page">
      <label className="srOnly" htmlFor="otp-code">
        کد تایید
      </label>
      <div className="otpCodeField">
        <input
          ref={otpCodeTxtRef}
          type="tel"
          id="otp-code"
          maxLength="5"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="one-time-code"
        />
      </div>
      <input
        disabled={loading}
        type="button"
        id="otp-submit"
        aria-label="تایید کد"
        onClick={async () => {
          try {
            setLoading(true);
            const introPage = pages.intro;
            // if (runMode === RUN_MODES.DEBUG) {
            //   gotoPage({ page: introPage });
            //   setLoading(false);
            //   return;
            // }
            console.log("otp submit clicked");
            let code = otpCodeTxtRef.current.value;
            console.log("otp code is", code);
            const res = await submitOtp(code);
            store.set("isCreatedFamily", res.isCreatedFamily);
            const userStatus = await getStatus();
            // const invitations = await getFamilyRequests();
            // store.set("familyInvitations", invitations.request);
            gotoPage({ page: introPage });
            setLoading(false);
          } catch (error) {
            console.error(error);
            setError(error);
            setLoading(false);
          }
        }}
      />
      <button
        className="resendOTPBtn"
        aria-label="ارسال دوباره کد"
        onClick={async () => {
          console.log("resendBtn clicked");
          try {
            await requestOtp(store.get("otp-number"));
          } catch (error) {
            setError(error);
          }
        }}
      ></button>
      <FixedErrMsgArea msg={error} />
    </div>
  );
};

export default OTPVerify;
